import { UserRole } from '../enums/user-role.enum';

/** True only when Mongo/backend roles include admin — no environment bypass. */
export function userHasAdminAccess(
  roles?: ReadonlyArray<string | UserRole> | null,
): boolean {
  if (!roles || !Array.isArray(roles)) {
    return false;
  }
  return roles.includes(UserRole.ADMIN) || roles.includes('admin');
}
